module.exports = __webpack_public_path__ + "img/img_12371_1.8df0cfa8.webp";